import React from 'react';
import PropTypes from 'prop-types';

import {Alert, Box, CircularProgress, Stack} from 'views/components';
import {translate} from 'views/module';

import WorkflowCard from './WorkflowCard';

import backend from 'utils/backend';

const Workflows = (props) => {
  const {clientId, refresh} = props;

  const [workflows, setWorkflows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    let isCancelled = false;

    const loadWorkflows = async () => {
      setLoading(true);
      setError(null);

      try {
        const result = await backend.loom.loomLead.workflow.listForClient(clientId);
        if (!isCancelled) setWorkflows(result);
      } catch (loadError) {
        console.error(loadError);
        if (isCancelled) return;
        // Stale cards under a load error would read as current, so the failed load clears them.
        setWorkflows([]);
        setError(translate('loomLead.LoomLeadDetail.Workflows.LoadError'));
      } finally {
        if (!isCancelled) setLoading(false);
      }
    };

    loadWorkflows();

    return () => {
      isCancelled = true;
    };
  }, [clientId, refresh]);

  if (loading) {
    return (
      <Box sx={{display: 'flex', justifyContent: 'center', py: 3}}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack spacing={2} sx={{p: 2}}>
      {
        error &&
        <Alert severity='error'>{error}</Alert>
      }
      {
        !error && workflows.length === 0 &&
        <Alert severity='info'>{translate('loomLead.LoomLeadDetail.Workflows.Empty')}</Alert>
      }
      {
        workflows.map((workflow) => (
          <WorkflowCard
            key={workflow.id}
            workflow={workflow}
          />
        ))
      }
    </Stack>
  );
};
Workflows.propTypes = {
  clientId: PropTypes.string.isRequired,
  refresh: PropTypes.number.isRequired,
};

export default React.memo(Workflows);
